import React from 'react';
import { View, Text, TouchableOpacity, Image } from 'react-native';
import styles from '../../styles/AppStyles';

interface LicenseIssueScreenProps {
  title: string;
  message: string;
  onContinueCheckout: () => void | Promise<void>;
}

export default function LicenseIssueScreen({
  title,
  message,
  onContinueCheckout,
}: LicenseIssueScreenProps) {
  return (
    <View style={styles.authContainer}>
      <View style={styles.authWrapper}>
        <View style={styles.authLogoPane}>
          <Image
            source={require('../../assets/LandingatorLogo.png')}
            style={{ width: undefined, height: '100%', resizeMode: 'contain' }}
          />
        </View>
        <View style={styles.authFormPane}>
          <View style={styles.authCard}>
            <Text style={styles.authTitle}>{title}</Text>
            <Text style={{ color: '#fff', textAlign: 'center', marginBottom: 16 }}>{message}</Text>
            <TouchableOpacity
              style={[styles.button, styles.primaryButton]}
              onPress={onContinueCheckout}
            >
              <Text style={styles.primaryButtonText}>Continue Checkout</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
}
